var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTexts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.605,
    height: 16.04,
    viewBox: "0 0 19.605 16.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text_13742043",
    transform: "translate(-1 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8921",
    "data-name": "Path 8921",
    d: "M21.129,11.3H14.891a.891.891,0,0,0-.891.891v1.248a.891.891,0,0,0,1.782,0v-.356h1.337v5.079h-.98a.891.891,0,0,0,0,1.782h3.743a.891.891,0,0,0,0-1.782H18.9V13.082h1.337v.356a.891.891,0,1,0,1.782,0V12.191A.891.891,0,0,0,21.129,11.3Z",
    transform: "translate(-1.415 -0.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8922",
    "data-name": "Path 8922",
    d: "M12.189,17.258H9.911V4.782h5.347v.692a.891.891,0,1,0,1.782,0V3.891A.891.891,0,0,0,16.149,3H1.891A.891.891,0,0,0,1,3.891V5.475a.891.891,0,0,0,1.782,0V4.782H8.129V17.258H5.851a.891.891,0,0,0,0,1.782h6.338a.891.891,0,0,0,0-1.782Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexts);
export default __webpack_public_path__ + "static/media/texts.7b8e08a6.svg";
export { ForwardRef as ReactComponent };